import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const mainAsideNews: TSkeletons = [{ className: 'aside-news-preview-main-news-loader', width: null, height: '240px' }]

export const additionalAsideNews: TSkeletons = Array(3).fill({
  className: 'aside-news-preview-simple-news-loader',
})
